import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export enum LayoutType {
  Empty = 'empty',
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom'
}

export enum ObjectFit {
  Cover = 'cover',
  Fill = 'fill',
  Contain = 'contain',
  None = 'none'
}

export const CardWidgetStaticSchema = BaseWidgetSchema(WidgetType.Card).extend({
  imageHorizontalSpace: z.number(),
  imageVerticalSpace: z.number(),
  layoutType: z.nativeEnum(LayoutType),
  image: z.object({
    src: z.string(),
    alt: z.string(),
    mobileSrc: z.string(),
    objectFit: z.nativeEnum(ObjectFit),
    mobileObjectFit: z.nativeEnum(ObjectFit),
    isDecorative: z.boolean().optional()
  }),
  style: z.record(z.unknown())
});

export type CardWidgetStaticSchemaType = z.infer<typeof CardWidgetStaticSchema>;
